(() => {
	let contentElement = document.getElementById('player_content');
	let playerElement  = document.getElementById('player_pane');
	if (contentElement && playerElement) {
		let buttons    = document.querySelectorAll('[data-listen]');
		let activeButton;
		let haltEvent  = (event) => {
			event.stopPropagation();
			event.preventDefault();
		};
		let showPlayer = (uri, type) => {
			let embedUrl             = type === 'soundcloud' ? uri.replace('auto_play=false', 'auto_play=true').replace('visual=true', 'visual=false') : uri;
			contentElement.innerHTML = '<iframe src="' + embedUrl + '"></iframe>';
			playerElement.className  = 'player_active player_pane_' + type;
		};

		let hidePlayer   = () => {
			if (!activeButton) {
				return;
			}
			contentElement.innerHTML = '';
			playerElement.className  = '';
			activeButton.classList.remove('active');
			activeButton = null;
		};
		let togglePlayer = function (e) {
			haltEvent(e);
			if (activeButton) {
				if (this === activeButton) {
					hidePlayer();
					return;
				}
				else {
					hidePlayer();
				}
			}
			activeButton = this;
			activeButton.classList.add('active');
			showPlayer(this.getAttribute('data-listen-uri'), this.getAttribute('data-listen-type'));
		};

		Array.prototype.forEach.call(buttons, (button) => {
			button.addEventListener('click', togglePlayer);
		});
	}
})();